var $371167f8ab40ff4e$exports = {};
$371167f8ab40ff4e$exports = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};


export {$371167f8ab40ff4e$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
